import { getApps, initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";


// I have this hardcoded here for now because it's not a secret, but it can be extracted to a separate file/env variable if desired.
const firebaseConfig = {
  apiKey: "AIzaSyB5qeP5WXSTjGpIOmshAiz9jzYV_PvWjls",
  authDomain: "sparkk-ai.firebaseapp.com",
  projectId: "sparkk-ai",
  storageBucket: "sparkk-ai.appspot.com",
  messagingSenderId: "608168862557",
  appId: "1:608168862557:web:42044e462136adc2fb7eb4",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);